import React from 'react';
import PropTypes from 'prop-types';

import cn from '../../lib/class-name';

/**
 *  All children of the `TabBar` must be of type `TabBarItem`
 */
const TabBar = ({ children, ghost, classNames }) => (
  <div className={cn('hpl2-TabBar', { ghost }, classNames)}>{children}</div>
);

TabBar.propTypes = {
  /** Optional array of CSS utility classes. */
  classNames: PropTypes.arrayOf(PropTypes.string),
  /** An array of TabBarItems. */
  children: PropTypes.node,
  /** Optional modifier to remove bottom border. */
  ghost: PropTypes.bool,
};

export default TabBar;
